import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchHosts = async (params = {}) => {
  const { data } = await api.get("/hosts", { params });
  return data;
};

export const toggleFavorite = async (id, is_favorite) => {
  const { data } = await api.patch(`/hosts/${id}/favorite`, { is_favorite });
  return data;
};

export const generateHostnames = async (count) => {
  const { data } = await api.post("/generate", { count });
  return data.hostnames;
};

export const fetchMeta = async () => {
  const { data } = await api.get("/meta");
  return data;
};
